import { createRequest } from "helpers/tools";

/**
 * Get Google Sheets Lead Auth URL
 * @returns {Promise} Response with url (in data.url)
 */
export const getGoogleSheetsLeadAuthUrl = async () => {
    return await createRequest({
        suffix: `lead/service/google-sheets/auth-url`,
        handleError: true,
        method: "get",
    });
};

/**
 * Exchange OAuth code for credentials and get spreadsheets list
 * @param {Object} payload - { code: string }
 * @returns {Promise} Response with install_id and spreadsheets
 */
export const googleSheetsLeadSpreadsheets = async (payload) => {
    return await createRequest({
        suffix: `lead/service/google-sheets/spreadsheets`,
        handleError: true,
        method: "post",
        payload,
    });
};

/**
 * Get pages (sheets) for a spreadsheet
 * @param {Object} payload - { install_id, spreadsheet_id }
 * @returns {Promise} Response with pages array
 */
export const googleSheetsLeadPages = async (payload) => {
    return await createRequest({
        suffix: `lead/service/google-sheets/pages`,
        handleError: true,
        method: "post",
        payload,
    });
};

/**
 * Get column headers (fields) for a page
 * @param {Object} payload - { install_id, spreadsheet_id, page_name }
 * @returns {Promise} Response with fields array
 */
export const googleSheetsLeadFields = async (payload) => {
    return await createRequest({
        suffix: `lead/service/google-sheets/fields`,
        handleError: true,
        method: "post",
        payload,
    });
};

/**
 * Store Google Sheets Lead destination configuration
 * @param {Object} payload - { name, install_id, spreadsheet_id, spreadsheet_name, page_name }
 * @returns {Promise} Response with service_id, destination_id, and fields
 */
export const googleSheetsLeadStore = async (payload) => {
    return await createRequest({
        suffix: `lead/service/google-sheets/store`,
        handleError: true,
        method: "post",
        payload,
    });
};
